import { render } from "./sucursales.vue?vue&type=template&id=51ac3779"
import script from "./sucursales.vue?vue&type=script&lang=js"
export * from "./sucursales.vue?vue&type=script&lang=js"

import "./sucursales.vue?vue&type=style&index=0&id=51ac3779&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__